import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmerAnimation = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const popupAnimation = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const SkeletonBase = styled.div`
  background: #e6e6e6;
  background-image: linear-gradient(to right, #e6e6e6 0%, #d9d9d9 20%, #e6e6e6 40%, #e6e6e6 100%);
  background-repeat: no-repeat;
  background-size: 800px 100%;
  animation: ${shimmerAnimation} 1.5s infinite linear;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 65%;
  margin: auto;
`;

const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 20px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: scale(0.9);
  animation: ${popupAnimation} 0.5s linear forwards;
`;

const TitleLine = styled(SkeletonBase)`
  height: 24px;
  width: ${(props) => props.width || '120px'};
  border-radius: 4px;
  margin-bottom: 16px;
`;

const FilenameLine = styled(SkeletonBase)`
  height: 16px;
  width: 200px;
  border-radius: 4px;
  margin-bottom: 24px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: auto;
`;

const ButtonLine = styled(SkeletonBase)`
  height: 16px;
  width: ${(props) => props.width || '80px'};
  border-radius: 4px;
`;

const SkeletonCard = ({ type, delay }) => (
  <Card style={{ animationDelay: `${delay}s` }}>
    <TitleLine width={type === 'upload' ? '150px' : '120px'} />
    <FilenameLine />
    <ButtonsContainer>
      <ButtonLine width="70px" />
      {type === 'title' && <ButtonLine width="90px" />}
    </ButtonsContainer>
  </Card>
);

const SkeletonLoader = ({ cardCount = 4 }) => {
  return (
    <CardsContainer>
      <SkeletonCard type="title" delay={0.1} />

      {Array.from({ length: cardCount - 1 }, (_, index) => (
        <SkeletonCard key={index} type="upload" delay={0.2 + index * 0.1} />
      ))}
    </CardsContainer>
  );
};

export default SkeletonLoader;
